import * as React from "react";
import { Col } from "reactstrap";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";

// Utils
import { returnWeekChartData } from "./Utils";

class WeekChart extends React.Component<{ requests: Array<any> }> {
  render() {
    const { requests } = this.props;

    const chartData = returnWeekChartData(requests);

    return (
      <Col xs={12} md={6} lg={6}>
        <ResponsiveContainer>
          <LineChart
            width={600}
            height={300}
            data={chartData}
            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
          >
            <XAxis dataKey="name" />
            <YAxis />
            <CartesianGrid strokeDasharray="3 3" />
            <Tooltip />
            <Legend />
            <Line
              type="monotone"
              dataKey="Received"
              stroke="#ffa366"
              activeDot={{ r: 8 }}
            />
            <Line type="monotone" dataKey="Accepted" stroke="#33cccc" />
          </LineChart>
        </ResponsiveContainer>
      </Col>
    );
  }
}

export default WeekChart;



// WEBPACK FOOTER //
// ./src/Containers/Reports/CustomerRequestsCharts/WeekChart.tsx